import { Component, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
  CdkDrag,
  CdkDropList,
  CdkDragPlaceholder,
} from '@angular/cdk/drag-drop';
import { ComponentEnum } from './poc-component.enum';

@Component({
  selector: 'app-poc-report',
  templateUrl: './poc-report.component.html',
  styleUrls: ['./poc-report.component.scss']
})
export class PocReportComponent implements OnInit {

  @Input() params: any;

  ComponentEnum = ComponentEnum;

  componentList = [
    { id: 's4', title: 'Total Lands for Properties', imgUrl: 'assets/poc/overview1.png', enabled: true, settings: {} },
    { id: 's5', title: 'Average Land Area', imgUrl: 'assets/poc/overview2.png', enabled: true, settings: {} },
    { id: 's6', title: 'Land Development Rate', imgUrl: 'assets/poc/overview3.png', enabled: true, settings: {} },
    { id: 'chart5', title: 'Annual Average Rent Rate (Grade Wise)', imgUrl: 'assets/poc/overview11.png', enabled: true, settings: {} },
    { id: 'chart4', title: 'Occupancy Rate (in all types)', imgUrl: 'assets/poc/overview12.png', enabled: true, settings: {} },
    { id: 'chart6', title: 'chart41', imgUrl: 'assets/poc/chart2.png', enabled: true, settings: {} },
    { id: 'chart7', title: 'chart31', imgUrl: 'assets/poc/chart1.png', enabled: true, settings: {} },
    { id: 'table2', title: 'table12', imgUrl: 'assets/poc/table1.png', enabled: true, settings: {} },
  ]

  defaultLayout: any = [
    {
      id: 'col1',
      sections: [
        {
          id: 's1', title: 'Total Lands for Properties', imgUrl: 'assets/poc/overview1.png', enabled: true,
          settings: {
            componentName: ComponentEnum.TotalLandProperty
          }
        },
        {
          id: 's2', title: 'Average Land Area', imgUrl: 'assets/poc/overview2.png', enabled: true,
          settings: {
            componentName: ComponentEnum.AverageLandArea
          }
        },
        {
          id: 's3', title: 'Land Development Rate', imgUrl: 'assets/poc/overview3.png', enabled: true,
          settings: {
            componentName: ComponentEnum.LandDevelopmentRate
          }
        },
      ]
    },
    {
      id: 'col3',
      sections: [
        {
          id: 'chart3', title: 'Residential Land Supply 5 Years', imgUrl: 'assets/poc/chart1.png', enabled: true,
          settings: {
            componentName: ComponentEnum.ResidentialLandSupply5Years
          }
        },
      ]
    },
    {
      id: 'col4',
      sections: [
        {
          id: 'chart4', title: 'Independent Properties', imgUrl: 'assets/poc/chart2.png', enabled: true,
          settings: {
            componentName: ComponentEnum.IndependentProperties
          }
        },
      ]
    },
    {
      id: 'col2',
      sections: [
        {
          id: 'chart1', title: 'Governmental Properties', imgUrl: 'assets/poc/overview11.png', enabled: true,
           settings: {
            componentName: ComponentEnum.GovernmentalProperties
          }
        },
      ]
    },
    {
      id: 'col5',
      sections: [
        {
          id: 'table1', title: 'House Villa Projects', imgUrl: 'assets/poc/table1.png', enabled: true,
          settings: {
            componentName: ComponentEnum.HouseVillaProjects
          }
        },
      ]
    }
  ];
  connectedDropLists: string[] = [];
  edit = false;

  originalLayout: any[] = [];
  constructor() {

  }


  ngOnInit() {
    this.originalLayout = JSON.parse(JSON.stringify(this.defaultLayout)); // data copy

    this.loadLayout();
    this.connectedDropLists = [...this.defaultLayout.map((c: any) => c.id), ...this.componentList.map((c: any) => c.id)];
  }

  trackByColumn(index: number, col: any) {
    return col.id;
  }

  trackBySection(index: number, sec: any) {
    return sec.id;
  }


  editLayout() {
    this.edit = true;
  }
  cancel() {
    this.defaultLayout = this.originalLayout;
    this.saveLayout();
    //update dom list view
    this.connectedDropLists = [...this.defaultLayout.map((c: any) => c.id), ...this.componentList.map((c: any) => c.id)];
    this.edit = false;
  }
  loadLayout() {
    const saved = localStorage.getItem('report_layout');
    if (saved) {
      this.defaultLayout = JSON.parse(saved);
    }
  }

  saveLayout() {
    this.edit = false;
    localStorage.setItem('report_layout', JSON.stringify(this.defaultLayout));
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  deleteSection(section: any, column: any) {
    column.sections = column.sections.filter((s: any) => s.id !== section.id);

    const exists = this.componentList.some(c => c.id === section.id);
    if (!exists) {
      this.componentList.push(section);
    }

    this.connectedDropLists = [
      ...this.defaultLayout.map((c: any) => c.id),
      ...this.componentList.map((c: any) => c.id)
    ];
  }

  addColumn() {
    const newColumnId = 'col' + (this.defaultLayout.length + 1);

    this.defaultLayout.push({
      id: newColumnId,
      sections: []
    });


    this.connectedDropLists = [
      ...this.defaultLayout.map((c: any) => c.id),
      ...this.componentList.map((c: any) => c.id)
    ];
  }


  removeColumn(column: any) {
    column.sections.forEach((section: any) => {
      const exists = this.componentList.some((c: any) => c.id === section.id);
      if (!exists) {
        this.componentList.push(section);
      }
    });

    this.defaultLayout = this.defaultLayout.filter((c: any) => c.id !== column.id);


    this.connectedDropLists = [
      ...this.defaultLayout.map((c: any) => c.id),
      ...this.componentList.map((c: any) => c.id)
    ];
  }


}